import { observer } from "mobx-react-lite"
import { Button } from "@/components/ui/button"
import type { CounterStoreType } from "@/stores/CounterStore"

interface CounterProps {
  store: CounterStoreType
}

export const Counter = observer(({ store }: CounterProps) => {
  return (
    <div className="flex flex-col items-center gap-4 p-6 border rounded-lg">
      <h2 className="text-2xl font-bold">Counter Example</h2>
      <div className="text-4xl font-mono">{store.count}</div>
      <div className="flex gap-2">
        <Button onClick={() => store.decrement()} variant="outline">
          Decrement
        </Button>
        <Button onClick={() => store.reset()} variant="secondary">
          Reset
        </Button>
        <Button onClick={() => store.increment()}>Increment</Button>
      </div>
      {store.isPositive && <p className="text-sm text-green-600">Count is positive!</p>}
      {store.isNegative && <p className="text-sm text-red-600">Count is negative!</p>}
    </div>
  )
})

Counter.displayName = "Counter"
